import React, { useEffect, useState } from "react";
import styles from "./products.module.css";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { setMetaTags } from "../../utils/util_functions";
import { getLoading, getProducts, getRoutes } from "../../services/selectors";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../components/loader/loader";
import { SET_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { getDataFromProductRoutes } from "../../utils/util_functions";


const ProductPage = () => {

  const getCategoryPath = (routes, products, lastSlug) => {
    if (products.find(p => p.slug === lastSlug)) {
      return location.pathname.replace('/products', '/catalog').replace(`/${lastSlug}`, '');
    }
    return location.pathname.replace('/products', '/catalog');
  }

  const location = useLocation();
  const isLoading = useSelector(getLoading);
  const products = useSelector(getProducts);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const routes = useSelector(getRoutes);

  let { slug1, slug2, slug3, slug4 } = useParams();
  const lastSlug = slug4 ? slug4 : slug3 ? slug3 : slug2 ? slug2 : slug1;

  const {
    metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromProductRoutes(location.pathname, navigate, routes, slug1);

  const [currProduct, setCurrProduct] = useState({});
  const [currCategory, setCurrCategory] = useState({});

  useEffect(() => {

    dispatch({
      type: SET_PATH_PARAMS,
      uid: '',
      token: '',
      slug1: slug1 || '',
      slug2: slug2 || '',
      slug3: slug3 || '',
      slug4: slug4 || ''
    });

    if (products.length > 0 && !isLoading && routes.some(r => r.path.startsWith('/products/'))) {
      let categoryPath = getCategoryPath(routes, products, lastSlug);
      setCurrCategory(routes.find(r => r.path === categoryPath));
      setCurrProduct(products.find(p => p.path === location.pathname));
      if (!currProduct && currCategory) {
        navigate(`${currCategory.path}`);
      }
      if (!currProduct && !currCategory) {
        navigate('/not-found', { replace: true });
      }
    }
    // eslint-disable-next-line
  }, [products, routes, location, isLoading, currCategory, currProduct]);


  useEffect(() => {
    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, [metaTitle, metaDescription, metaKeywords, metaRobots]);

  return (
    <main className='main'>
      {isLoading ? <Loader /> :
        <>
          {currProduct ?
            <>
              <h1 className="title">{currProduct.name}</h1>
              <ul>
                {Object.keys(currProduct).map((key, index) => <li key={index}><span className="color">{key}</span>: {currProduct[key]?.toString()}</li>) }
              </ul>

            </> : null
          }
        </>
      }
    </main>
  );
};

export default ProductPage;
